export const truncate = (text: string, charsNumber = 10) =>
  `${text.slice(0, charsNumber)}${text.length > charsNumber ? "..." : ""}`;
